// Активные сессии пользователя.
//
// Запросы намеренно не workspace-scoped: сессия принадлежит человеку, а не
// рабочему пространству, и список обязан открываться, даже когда выбранный
// workspace стал недоступен.
import { apiDelete, apiGet, apiPost } from '../../../shared/api-client/index.js';

export interface SessionItem {
  id: string;
  createdAt: string;
  expiresAt: string;
  lastUsedAt: string | null;
  userAgent: string | null;
  ip: string | null;
  /** Сессия, из которой открыта эта страница. */
  current: boolean;
}

export interface ListSessionsResponse {
  sessions: SessionItem[];
}

export async function listActiveSessions(): Promise<ListSessionsResponse> {
  return apiGet<ListSessionsResponse>('/auth/sessions');
}

export async function revokeSession(sessionId: string): Promise<void> {
  await apiDelete<void>(`/auth/sessions/${sessionId}`);
}

/** «Выйти везде»: закрывает все сессии, кроме текущей. */
export async function revokeOtherSessions(): Promise<{ count: number }> {
  return apiPost<{ count: number }, Record<string, never>>('/auth/sessions/revoke-others', {});
}
